/* Petart product page customizer. */
(function () {
  "use strict";

  var CLIENT_KEY = "petart_client_id";
  var DESIGN_STORE_PREFIX = "petart_design_v1_";
  var DESIGN_PROPERTY = "_petart_design";
  var PREVIEW_PROPERTY = "_petart_preview";
  var NAME_PROPERTY = "Name";
  var POLL_INTERVAL = 2000;
  var POLL_TIMEOUT = 150000;
  var MAX_BYTES = 10 * 1024 * 1024;
  var ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];
  var CROP_OUTPUT_EDGE = 1600;

  // The server reports a single 0..100 number; these turn it into language that
  // matches what is actually happening, so a 60 second wait reads as progress.
  var STAGES = [
    { at: 0, text: "Preparing your image..." },
    { at: 12, text: "Uploading your photo..." },
    { at: 25, text: "Drawing your artwork..." },
    { at: 65, text: "Placing it on the product..." },
    { at: 80, text: "Polishing the final preview..." },
    { at: 100, text: "Your design is ready" },
  ];

  function stageText(value) {
    var text = STAGES[0].text;
    for (var index = 0; index < STAGES.length; index += 1) {
      if (value >= STAGES[index].at) text = STAGES[index].text;
    }
    return text;
  }

  function parseRatio(value) {
    var parts = String(value || "1:1").split(":");
    var w = parseFloat(parts[0]);
    var h = parseFloat(parts[1]);
    if (!w || !h || w <= 0 || h <= 0) return 1;
    return w / h;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  var SUPPORTS_ASPECT_RATIO =
    typeof window.CSS === "object" &&
    typeof window.CSS.supports === "function" &&
    window.CSS.supports("aspect-ratio", "1");

  /**
   * Without aspect-ratio the frame collapses to zero height and the whole crop
   * step becomes unusable, so pre-2021 browsers get an explicit pixel height.
   */
  function sizeCropFrame(frame, ratio) {
    if (!frame) return;
    var maxHeight = Math.min(Math.round(window.innerHeight * 0.28), 220);
    var parent = frame.parentNode;
    var available =
      (frame.clientWidth > 0 && frame.clientWidth) ||
      (parent && parent.clientWidth > 0 && parent.clientWidth) ||
      (frame.closest && frame.closest(".petart__dialog") && frame.closest(".petart__dialog").clientWidth - 40) ||
      280;
    available = Math.max(120, Math.min(available, 280));

    var width = available;
    var height = Math.round(width / ratio);
    if (height > maxHeight) {
      height = maxHeight;
      width = Math.round(height * ratio);
    }

    // Always set both axes in px. Relying on aspect-ratio alone collapses to 0
    // when the parent was still `hidden` at the moment we first measured it.
    frame.style.width = width + "px";
    frame.style.height = height + "px";
    frame.style.maxHeight = maxHeight + "px";
    frame.style.aspectRatio = "";
  }

  function clientId() {
    try {
      var id = window.localStorage.getItem(CLIENT_KEY);
      if (!id) {
        id =
          window.crypto && window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : String(Date.now()) + Math.random().toString(16).slice(2);
        window.localStorage.setItem(CLIENT_KEY, id);
      }
      return id;
    } catch (error) {
      return "anonymous";
    }
  }

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
      credentials: "same-origin",
    }).then(readJson);
  }

  function getJson(url) {
    return fetch(url, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    }).then(readJson);
  }

  function readJson(response) {
    return response.text().then(function (text) {
      var data = {};
      try {
        data = text ? JSON.parse(text) : {};
      } catch (error) {
        throw new Error("Unexpected response from the design service.");
      }
      if (!response.ok) {
        throw new Error(data.error || "Request failed (" + response.status + ")");
      }
      return data;
    });
  }

  function Customizer(root) {
    this.root = root;
    this.proxy = (root.dataset.proxy || "/apps/petart").replace(/\/+$/, "");
    this.productId = root.dataset.productId || "";
    this.config = null;
    this.file = null;
    this.tone = "auto";
    this.pending = null;
    this.designId = "";
    this.previewUrl = "";
    this.pollTimer = null;
    this.formGuardBound = false;
    this.generating = false;
    this.remaining = -1;
    this.crop = null;
    this.sourceKey = "";
    this.referenceKey = "";
    this.referenceFile = null;
    this.referenceObjectUrl = "";
    this.analyzeToken = 0;
    this.attributes = {};
    this.stepIndex = 0;
    this.steps = [];
    this.modalMode = "create";
  }

  /**
   * The size rail and gallery overlay get re-parented into the theme's markup,
   * so a lookup scoped to `root` alone would miss them and return null.
   */
  Customizer.prototype.scopes = function () {
    var list = [this.root];
    if (this.modal && !this.root.contains(this.modal)) list.push(this.modal);
    if (this.galleryStage && !this.root.contains(this.galleryStage)) list.push(this.galleryStage);
    if (this.sizeRail && !this.root.contains(this.sizeRail)) list.push(this.sizeRail);
    return list;
  };

  Customizer.prototype.pick = function (selector) {
    var scopes = this.scopes();
    for (var index = 0; index < scopes.length; index += 1) {
      var scope = scopes[index];
      if (scope.matches && scope.matches(selector)) return scope;
      var found = scope.querySelector(selector);
      if (found) return found;
    }
    return null;
  };

  Customizer.prototype.pickAll = function (selector) {
    var nodes = [];
    this.scopes().forEach(function (scope) {
      if (scope.matches && scope.matches(selector) && nodes.indexOf(scope) === -1) nodes.push(scope);
      Array.prototype.slice.call(scope.querySelectorAll(selector)).forEach(function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });
    return nodes;
  };

  Customizer.prototype.init = function () {
    var self = this;
    this.readInlineConfig()
      .then(function (config) {
        if (!config || !config.enabled) return;
        if (!config.scene) config.scene = {};
        if (!config.scene.url) config.scene.url = self.root.dataset.productImage || "";
        var presentation = (config.ui && config.ui.presentation) || "inline";
        var needsScene = presentation === "scene" || config.generateMode !== "none";
        if (needsScene && !config.scene.url) return;
        self.config = config;
        self.attributes = {};
        self.render();
        self.bind();
        self.enforceDesignRequirement();
        self.restorePersistedDesign();
        self.initDesignFromQuery();
        if (self.shouldOpenEditorFromUrl() && self.hasExistingDesign()) {
          self.openModal({ edit: true });
        }
      })
      .catch(function (error) {
        console.warn("[petart] init failed", error);
      });
  };

  Customizer.prototype.readInlineConfig = function () {
    var node = this.pick("[data-petart-config]");
    var inline = null;
    if (node && node.textContent) {
      try {
        inline = JSON.parse(node.textContent);
      } catch (error) {
        inline = null;
      }
    }
    if (inline && inline.enabled) {
      // Older metafields predate ui.layout — pull the live config once so new
      // per-preset chrome lands without forcing a merchant re-save.
      if (inline.ui && inline.ui.layout) return Promise.resolve(inline);
      if (this.root.dataset.allowFallback !== "true") return Promise.resolve(inline);
      return getJson(
        this.proxy + "/config?product_id=" + encodeURIComponent(this.productId),
      )
        .then(function (remote) {
          if (remote && remote.enabled && remote.ui) {
            inline.ui = Object.assign({}, inline.ui || {}, remote.ui);
          }
          return inline;
        })
        .catch(function () {
          return inline;
        });
    }
    if (this.root.dataset.allowFallback !== "true") return Promise.resolve(inline);

    // The metafield can lag right after the template is saved in the admin.
    return getJson(
      this.proxy + "/config?product_id=" + encodeURIComponent(this.productId),
    ).catch(function () {
      return null;
    });
  };

  Customizer.prototype.presentation = function () {
    return (this.config && this.config.ui && this.config.ui.presentation) || "inline";
  };

  Customizer.prototype.generateMode = function () {
    return (this.config && this.config.generateMode) || "ai";
  };

  Customizer.prototype.allowPhoto = function () {
    return this.generateMode() === "ai" && this.config.allowPhoto !== false;
  };

  Customizer.prototype.render = function () {
    var config = this.config;
    var ui = config.ui || {};
    var presentation = this.presentation();
    var sceneUrl = this.sceneUrl();

    this.root.setAttribute("data-petart-presentation", presentation);
    this.mountModal();

    var scene = this.pick("[data-petart-scene]");
    if (scene) {
      scene.src = sceneUrl;
      scene.alt = ui.cta || "Customize this product";
    }

    var sizeCta = this.pick("[data-petart-size-cta]");
    if (sizeCta) sizeCta.textContent = ui.cta || "Upload photo";
    var dropCta = this.pick("[data-petart-dropzone-cta]");
    if (dropCta) dropCta.textContent = "Upload an image";
    this.setText("[data-petart-modal-title]", ui.title || "Create your design");
    this.setText("[data-petart-modal-subtitle]", "");
    this.applyUiLayout(ui.layout || "standard", ui);

    var showPhoto = this.allowPhoto();
    this.setHidden("[data-petart-image-section]", !showPhoto);
    this.setHidden("[data-petart-tabs]", !showPhoto || !config.allowPromptOnly);

    this.setHidden("[data-petart-name-field]", !config.allowName);
    this.setHidden("[data-petart-name-divider]", !config.allowName);
    if (config.allowName) {
      var maxChars = config.nameMaxLength || 24;
      this.setText("[data-petart-name-label]", config.nameLabel || "Your text");
      this.setText("[data-petart-name-hint]", "Max. " + maxChars + " characters");
      var nameInput = this.pick("[data-petart-name]");
      if (nameInput) nameInput.maxLength = maxChars;
    }

    var hasTones = Boolean(config.allowTone && config.tones && config.tones.length);
    this.setHidden("[data-petart-tone-field]", !hasTones);
    if (hasTones) this.renderTones(config.tones);

    this.renderAttributes();

    var submitLabel = this.pick("[data-petart-submit-label]");
    if (submitLabel) {
      submitLabel.textContent = this.generateMode() === "none" ? "Save options" : "Create design";
    }

    if (presentation === "scene") {
      this.mountGalleryOverlay();
      this.mountSizeRail();
      this.positionHotspot();
      this.bindOpenTriggers();
      this.setHidden("[data-petart-inline]", true);
      this.setHidden("[data-petart-stepper]", true);
      this.refreshSizeRail();
      return;
    }

    this.setHidden("[data-petart-stage]", true);
    this.setHidden("[data-petart-size-rail]", true);
    this.setHidden("[data-petart-edit-bar]", true);
    if (this.modal) this.modal.hidden = true;

    var form = this.pick("[data-petart-panel='form']");
    if (presentation === "inline") {
      var inlineHost = this.pick("[data-petart-inline-host]");
      if (inlineHost && form && form.parentNode !== inlineHost) inlineHost.appendChild(form);
      this.setHidden("[data-petart-inline]", false);
      this.setHidden("[data-petart-stepper]", true);
    } else {
      var stepHost = this.pick("[data-petart-stepper-host]");
      if (stepHost && form && form.parentNode !== stepHost) stepHost.appendChild(form);
      this.setHidden("[data-petart-inline]", true);
      this.setHidden("[data-petart-stepper]", false);
      this.buildSteps();
      this.showStep(0);
    }
  };

  /**
   * Switches the modal chrome so glass / metal / wood / suncatcher products
   * feel like distinct Tedooo create-vision flows rather than one shared form.
   */
  Customizer.prototype.applyUiLayout = function (layout, ui) {
    var root = this.root;
    var modal = this.modal || this.pick("[data-petart-modal]");
    var nodes = [root, modal].filter(Boolean);
    nodes.forEach(function (node) {
      node.setAttribute("data-petart-layout", layout);
    });

    var imageLabels = {
      standard: "A. Image used for the design (optional)",
      glass: "A. Image used for the glass design (optional)",
      suncatcher: "A. Image used for the suncatcher (optional)",
      metal: "A. Image used for the metal design (optional)",
      wood: "A. Image used for the wood design (optional)",
    };
    var nameLabels = {
      standard: "B. Text used for the design (optional)",
      glass: "B. Text used for the glass design (optional)",
      suncatcher: "B. Text used for the suncatcher (optional)",
      metal: "B. Text cut into the metal (optional)",
      wood: "B. Text engraved on the wood (optional)",
    };
    var toneLabels = {
      standard: "Background tone color",
      glass: "Glass color palette",
      suncatcher: "Stained glass colors",
      metal: "Metal finish",
      wood: "Wood tone",
    };
    var helps = {
      standard: "Use a clear photo. Keep your subject centred for the best result.",
      glass:
        "Use a clear, well-lit photo. Front-facing portraits work best for glass mosaics.",
      suncatcher: "A centred, front-facing photo looks best inside the circular glass.",
      metal:
        "Optional: upload a reference photo, sketch, or logo. Or switch to Describe using AI and type your idea — we'll generate a laser-cut metal pattern.",
      wood: "Use a clear photo with good contrast — wood burning works best with strong outlines.",
    };

    this.setText("[data-petart-image-section-label]", imageLabels[layout] || imageLabels.standard);
    this.setText("[data-petart-name-section-label]", nameLabels[layout] || nameLabels.standard);
    this.setText("[data-petart-tone-section-label]", toneLabels[layout] || toneLabels.standard);
    this.setText("[data-petart-upload-help]", helps[layout] || helps.standard);
    this.setText("[data-petart-dual-upload-help]", helps[layout] || helps.standard);
    this.setText(
      "[data-petart-size-help]",
      ui.subtitle || helps[layout] || "Upload a clear photo to personalize this piece.",
    );

    var isMetal = layout === "metal";
    this.setHidden("[data-petart-upload-single]", isMetal);
    this.selectTab(this.activeTab());
    this.setHidden("[data-petart-image-section-label]", isMetal);
  };

  Customizer.prototype.layoutIsMetal = function () {
    return (this.root.getAttribute("data-petart-layout") || "") === "metal";
  };

  Customizer.prototype.attributesReady = function () {
    var list = (this.config && this.config.attributes) || [];
    for (var index = 0; index < list.length; index += 1) {
      var attribute = list[index];
      if (attribute.required && !String(this.attributes[attribute.id] || "").trim()) return false;
    }
    return true;
  };

  Customizer.prototype.renderAttributes = function () {
    var self = this;
    var host = this.pick("[data-petart-attributes]");
    var list = (this.config && this.config.attributes) || [];
    if (!host) return;
    host.textContent = "";
    if (!list.length) {
      host.hidden = true;
      return;
    }
    host.hidden = false;

    list
      .slice()
      .sort(function (a, b) {
        return (a.step || 1) - (b.step || 1);
      })
      .forEach(function (attribute) {
        var section = document.createElement("div");
        section.className = "petart__attr";
        section.setAttribute("data-petart-attr", attribute.id);
        section.setAttribute("data-petart-attr-step", String(attribute.step || 1));

        var label = document.createElement("p");
        label.className = "petart__section-label";
        label.textContent = attribute.label + (attribute.required ? " *" : "");
        section.appendChild(label);

        if (attribute.type === "text") {
          var input = document.createElement("input");
          input.className = "petart__input";
          input.type = "text";
          input.maxLength = attribute.maxLength || 80;
          input.value = self.attributes[attribute.id] || "";
          input.addEventListener("input", function () {
            self.attributes[attribute.id] = input.value;
            self.syncSubmitState();
          });
          section.appendChild(input);
        } else if (attribute.type === "select") {
          var select = document.createElement("select");
          select.className = "petart__input";
          (attribute.options || []).forEach(function (option) {
            var item = document.createElement("option");
            item.value = option.value;
            item.textContent = option.label;
            select.appendChild(item);
          });
          if (!self.attributes[attribute.id] && attribute.options && attribute.options[0]) {
            self.attributes[attribute.id] = attribute.options[0].value;
          }
          select.value = self.attributes[attribute.id] || "";
          select.addEventListener("change", function () {
            self.attributes[attribute.id] = select.value;
            self.syncSubmitState();
          });
          section.appendChild(select);
        } else {
          var row = document.createElement("div");
          row.className = "petart__swatches";
          (attribute.options || []).forEach(function (option, optionIndex) {
            if (!self.attributes[attribute.id] && optionIndex === 0) {
              self.attributes[attribute.id] = option.value;
            }
            var button = document.createElement("button");
            button.type = "button";
            button.className = "petart__swatch";
            button.setAttribute("aria-label", option.label);
            button.title = option.label;
            button.style.background = option.swatch || "#d4d4d4";
            if (self.attributes[attribute.id] === option.value) button.classList.add("is-active");
            button.addEventListener("click", function () {
              self.attributes[attribute.id] = option.value;
              Array.prototype.forEach.call(row.children, function (child) {
                child.classList.toggle("is-active", child === button);
              });
              self.syncSubmitState();
            });
            row.appendChild(button);
          });
          section.appendChild(row);
        }
        host.appendChild(section);
      });
    this.syncSubmitState();
  };

  Customizer.prototype.buildSteps = function () {
    var steps = [];
    if (this.allowPhoto()) steps.push({ id: "photo", label: "Photo" });
    var seen = {};
    ((this.config && this.config.attributes) || [])
      .slice()
      .sort(function (a, b) {
        return (a.step || 1) - (b.step || 1);
      })
      .forEach(function (attribute) {
        var key = "attr-" + (attribute.step || 1);
        if (!seen[key]) {
          seen[key] = true;
          steps.push({ id: key, label: attribute.label, step: attribute.step || 1 });
        }
      });
    if (this.config.allowName || this.config.allowTone) steps.push({ id: "text", label: "Text" });
    if (!steps.length) steps.push({ id: "options", label: "Options" });
    this.steps = steps;

    var nav = this.pick("[data-petart-stepper-nav]");
    if (!nav) return;
    nav.textContent = "";
    steps.forEach(function (step, index) {
      var item = document.createElement("li");
      item.textContent = index + 1 + ". " + step.label;
      item.setAttribute("data-petart-step-item", String(index));
      nav.appendChild(item);
    });
  };

  Customizer.prototype.showStep = function (index) {
    var steps = this.steps || [];
    this.stepIndex = Math.max(0, Math.min(index, steps.length - 1));
    var current = steps[this.stepIndex] || { id: "options" };

    this.setHidden("[data-petart-image-section]", current.id !== "photo");
    this.setHidden("[data-petart-name-field]", current.id !== "text" || !this.config.allowName);
    this.setHidden("[data-petart-name-divider]", current.id !== "text" || !this.config.allowName);
    this.setHidden("[data-petart-tone-field]", current.id !== "text" || !this.config.allowTone);

    this.pickAll("[data-petart-attr]").forEach(function (node) {
      var step = Number(node.getAttribute("data-petart-attr-step") || "1");
      node.hidden = current.id !== "attr-" + step && current.id !== "options";
    });
    var attrHost = this.pick("[data-petart-attributes]");
    if (attrHost) {
      attrHost.hidden = !(String(current.id).indexOf("attr-") === 0 || current.id === "options");
    }

    this.pickAll("[data-petart-step-item]").forEach(function (item) {
      item.classList.toggle("is-active", item.getAttribute("data-petart-step-item") === String(this.stepIndex));
    }, this);

    var prev = this.pick("[data-petart-step-prev]");
    var next = this.pick("[data-petart-step-next]");
    var submit = this.pick("[data-petart-submit]");
    var last = this.stepIndex >= steps.length - 1;
    if (prev) prev.hidden = this.stepIndex === 0;
    if (next) next.hidden = last;
    if (submit) submit.hidden = !last;
    this.syncSubmitState();
  };

  /**
   * Dawn animates the product info column with a transform, which makes it the
   * containing block for `position: fixed`. The overlay only fills the viewport
   * once it hangs off <body>.
   */
  Customizer.prototype.mountModal = function () {
    var modal = this.modal || this.root.querySelector("[data-petart-modal]");
    if (!modal) return;
    this.modal = modal;
    if (modal.parentNode === document.body) return;
    // The accent/radius custom properties are declared on the root element, so
    // they have to travel with the modal once it leaves that subtree.
    modal.setAttribute("style", this.root.getAttribute("style") || "");
    document.body.appendChild(modal);
  };

  Customizer.prototype.setText = function (selector, text) {
    var node = this.pick(selector);
    if (node) node.textContent = text;
  };

  Customizer.prototype.setHidden = function (selector, hidden) {
    var node = this.pick(selector);
    if (node) node.hidden = hidden;
  };

  Customizer.prototype.sceneUrl = function () {
    return (
      (this.config && this.config.scene && this.config.scene.url) ||
      this.root.dataset.productImage ||
      ""
    );
  };

  /**
   * Puts the upload hotspot on the theme's main product image so the customer
   * previews in the gallery, not a second image under the buy box.
   */
  Customizer.prototype.mountGalleryOverlay = function () {
    var stage = this.pick("[data-petart-stage]");
    if (!stage) return;
    this.galleryStage = stage;

    var host = this.galleryHost();
    if (!host) {
      stage.hidden = false;
      stage.classList.remove("petart__stage--overlay");
      return;
    }

    var style = window.getComputedStyle(host);
    if (style.position === "static") host.style.position = "relative";

    stage.classList.add("petart__stage--overlay");
    if (stage.parentNode !== host) host.appendChild(stage);
    stage.hidden = false;
  };

  Customizer.prototype.galleryHost = function () {
    var selectors = [
      ".product-media-container.media-type-image",
      ".product__media-item.is-active .product-media-container",
      "media-gallery .product-media-container",
      ".product__media .product-media-container",
      '[id^="MediaGallery"] .product-media-container',
    ];
    for (var index = 0; index < selectors.length; index += 1) {
      var node = document.querySelector(selectors[index]);
      if (node) return node;
    }
    return null;
  };

  Customizer.prototype.mountSizeRail = function () {
    var rail = this.pick("[data-petart-size-rail]") || this.sizeRail;
    if (!rail) return;
    this.sizeRail = rail;

    var anchor =
      document.querySelector("variant-selects") ||
      document.querySelector("variant-radios") ||
      document.querySelector(".product-form__input--pill") ||
      (document.querySelector('fieldset input[type="radio"]') &&
        document.querySelector('fieldset input[type="radio"]').closest("fieldset")) ||
      document.querySelector(".product-form__input") ||
      this.cartForm();

    if (anchor && anchor.parentNode) {
      if (rail.parentNode !== anchor.parentNode) {
        anchor.parentNode.insertBefore(rail, anchor);
      } else if (rail.nextSibling !== anchor) {
        anchor.parentNode.insertBefore(rail, anchor);
      }
    }
    this.refreshSizeRail();
  };

  Customizer.prototype.productPageUrl = function () {
    var handle = (this.config && this.config.productHandle) || "";
    if (handle) return "/products/" + handle;
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? "/products/" + match[1] : window.location.pathname;
  };

  Customizer.prototype.initDesignFromQuery = function () {
    var self = this;
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return;
    }

    var mode = params.get("petart");
    var designId = params.get("design");
    if (!designId || (mode !== "buy" && mode !== "edit")) return;

    getJson(this.proxy + "/design/" + encodeURIComponent(designId))
      .then(function (design) {
        if (!design || design.status !== "READY" || !design.previewUrl) return;
        self.designId = design.id;
        self.previewUrl = design.previewUrl;
        if (design.tone) {
          self.tone = design.tone;
          self.pickAll(".petart__tone").forEach(function (button) {
            button.classList.toggle("is-active", button.dataset.toneId === design.tone);
          });
        }
        if (design.promptText) {
          var uploadDescribe = self.pick("[data-petart-describe-upload]");
          var tabDescribe = self.pick("[data-petart-describe]");
          var editPrompt = self.pick("[data-petart-edit-prompt]");
          if (uploadDescribe) uploadDescribe.value = design.promptText;
          if (tabDescribe) tabDescribe.value = design.promptText;
          if (editPrompt) editPrompt.value = design.promptText;
          var customizeToggle = self.pick("[data-petart-customize-toggle]");
          if (customizeToggle) customizeToggle.checked = true;
          self.syncCustomizePanel();
          self.setHidden("[data-petart-customize]", false);
        }
        if (design.name) {
          var nameInput = self.pick("[data-petart-name]");
          if (nameInput) nameInput.value = design.name;
        }
        self.persistDesign();
        self.applyToForm();
        self.showPreviewOnGallery(design.previewUrl);
        self.refreshSizeRail();
        if (mode === "edit") self.openModal({ edit: true });
      })
      .catch(function () {
        /* localStorage fallback still works */
      });
  };

  /**
   * Direct listeners on every open trigger after nodes are moved out of root.
   * Document delegation alone is easy to break when themes stopPropagation.
   */
  Customizer.prototype.bindOpenTriggers = function () {
    var self = this;
    this.pickAll("[data-petart-open]").forEach(function (node) {
      if (node.dataset.petartBoundOpen === "true") return;
      node.dataset.petartBoundOpen = "true";
      node.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          self.openModal({ edit: self.shouldOpenForEdit(node) });
        },
        true,
      );
    });
  };

  /**
   * The rail doubles as the edit entry once a design exists.
   */
  Customizer.prototype.refreshSizeRail = function () {
    var rail = this.sizeRail || this.pick("[data-petart-size-rail]");
    if (!rail) return;

    var hasDesign = Boolean(this.previewUrl || (this.pending && this.pending.previewUrl));
    var label = rail.querySelector("[data-petart-size-label]");
    var status = rail.querySelector("[data-petart-size-status]");
    var cta = rail.querySelector("[data-petart-size-cta]");
    var value = rail.querySelector("[data-petart-size-value]");
    var tips = rail.querySelector("[data-petart-size-tips]");
    var help = rail.querySelector("[data-petart-size-help]");

    rail.hidden = false;
    rail.classList.toggle("petart__size-rail--ready", hasDesign);
    this.setHidden("[data-petart-edit-bar]", true);

    if (hasDesign) {
      if (label) label.textContent = "Your design";
      if (value) value.hidden = true;
      if (status) {
        status.textContent = this.generating
          ? "Creating your design…"
          : "Ready — shown in the product photos";
      }
      if (cta) cta.textContent = "Edit design";
      if (tips) tips.hidden = true;
      if (help) help.hidden = true;
      return;
    }

    if (label) label.textContent = "Personalize";
    if (tips) tips.hidden = false;
    if (help) help.hidden = false;

    var sizeText = this.selectedSizeLabel();
    if (value) {
      value.textContent = sizeText;
      value.hidden = !sizeText;
    }

    if (this.generating) {
      if (status) status.textContent = "Creating your design…";
      if (cta) cta.textContent = "View progress";
    } else {
      if (status) status.textContent = "Upload a photo or describe your idea";
      if (cta) cta.textContent = (this.config && this.config.ui && this.config.ui.cta) || "Upload photo";
    }
  };

  Customizer.prototype.selectedSizeLabel = function () {
    var form = this.cartForm();
    if (!form) return "";
    var checked = form.querySelector('input[type="radio"]:checked');
    if (checked) {
      var label = form.querySelector('label[for="' + checked.id + '"]');
      if (label) return label.textContent.trim();
      return checked.value;
    }
    var select = form.querySelector("select");
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      return select.selectedOptions[0].textContent.trim();
    }
    return "";
  };

  Customizer.prototype.positionHotspot = function () {
    var mask = this.config.mask || { x: 0.2, y: 0.2, w: 0.6, h: 0.6, shape: "circle" };
    var hotspot =
      (this.galleryStage && this.galleryStage.querySelector("[data-petart-hotspot]")) ||
      this.pick("[data-petart-hotspot]") ||
      this.pick("[data-petart-open]");
    if (!hotspot) return;
    hotspot.style.left = mask.x * 100 + "%";
    hotspot.style.top = mask.y * 100 + "%";
    hotspot.style.width = mask.w * 100 + "%";
    hotspot.style.height = mask.h * 100 + "%";
    hotspot.style.borderRadius = mask.shape === "rect" ? "6px" : "50%";
    // The compositor rotates the artwork by the same angle, so the clickable
    // area has to follow or it stops matching what the customer will receive.
    hotspot.style.transform = mask.rotation ? "rotate(" + mask.rotation + "deg)" : "";
  };

  Customizer.prototype.renderTones = function (tones) {
    var self = this;
    var container = this.pick("[data-petart-tones]");
    container.innerHTML = "";
    var layout = (this.config.ui && this.config.ui.layout) || "standard";
    var showLabels = layout === "metal";

    tones.forEach(function (tone, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "petart__tone" + (index === 0 ? " is-active" : "");
      button.dataset.toneId = tone.id;
      button.title = tone.label;

      if (tone.swatches && tone.swatches.length) {
        var strip = document.createElement("span");
        strip.className = "petart__tone-swatches";
        tone.swatches.forEach(function (color) {
          var swatch = document.createElement("span");
          swatch.style.background = color;
          strip.appendChild(swatch);
        });
        button.appendChild(strip);
      }

      if (showLabels || !tone.swatches || !tone.swatches.length) {
        var label = document.createElement("span");
        label.className = "petart__tone-label";
        label.textContent = tone.label;
        button.appendChild(label);
      }

      button.addEventListener("click", function () {
        self.tone = tone.id;
        self.pickAll(".petart__tone").forEach(function (node) {
          node.classList.toggle("is-active", node === button);
        });
      });

      container.appendChild(button);
    });

    this.tone = tones[0].id;
  };

  Customizer.prototype.bind = function () {
    var self = this;

    // Delegation: SIZE rail + gallery hotspot are moved outside this.root.
    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var open = target.closest("[data-petart-open]");
      if (open && self.ownsNode(open)) {
        event.preventDefault();
        var wantEdit = self.shouldOpenForEdit(open);
        self.openModal({ edit: wantEdit });
        return;
      }
      var editLink = target.closest("[data-petart-edit-link]");
      if (editLink && self.ownsNode(editLink)) {
        event.preventDefault();
        self.openModal({ edit: true });
        return;
      }
      var close = target.closest("[data-petart-close]");
      if (close && self.ownsNode(close)) {
        self.closeModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") self.closeModal();
    });

    this.pickAll("[data-petart-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        self.selectTab(tab.dataset.petartTab);
      });
    });

    var dropzone = this.pick("[data-petart-dropzone]");
    var fileInput = this.pick("[data-petart-file]");

    if (dropzone && fileInput) {
      dropzone.addEventListener("click", function () {
        fileInput.click();
      });
      ["dragenter", "dragover"].forEach(function (name) {
        dropzone.addEventListener(name, function (event) {
          event.preventDefault();
          dropzone.classList.add("is-dragging");
        });
      });
      ["dragleave", "drop"].forEach(function (name) {
        dropzone.addEventListener(name, function (event) {
          event.preventDefault();
          dropzone.classList.remove("is-dragging");
        });
      });
      dropzone.addEventListener("drop", function (event) {
        var dropped = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (dropped) self.setFile(dropped);
      });
      fileInput.addEventListener("change", function () {
        if (fileInput.files && fileInput.files[0]) self.setFile(fileInput.files[0]);
        fileInput.value = "";
      });
    }

    var designDropzone = this.pick("[data-petart-design-dropzone]");
    if (designDropzone && fileInput) {
      designDropzone.addEventListener("click", function () {
        fileInput.click();
      });
      ["dragenter", "dragover"].forEach(function (name) {
        designDropzone.addEventListener(name, function (event) {
          event.preventDefault();
          designDropzone.classList.add("is-dragging");
        });
      });
      ["dragleave", "drop"].forEach(function (name) {
        designDropzone.addEventListener(name, function (event) {
          event.preventDefault();
          designDropzone.classList.remove("is-dragging");
        });
      });
      designDropzone.addEventListener("drop", function (event) {
        var dropped = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (dropped) self.setFile(dropped);
      });
    }

    var referenceDropzone = this.pick("[data-petart-reference-dropzone]");
    var referenceInput = this.pick("[data-petart-reference-file]");
    if (referenceDropzone && referenceInput) {
      referenceDropzone.addEventListener("click", function () {
        referenceInput.click();
      });
      ["dragenter", "dragover"].forEach(function (name) {
        referenceDropzone.addEventListener(name, function (event) {
          event.preventDefault();
          referenceDropzone.classList.add("is-dragging");
        });
      });
      ["dragleave", "drop"].forEach(function (name) {
        referenceDropzone.addEventListener(name, function (event) {
          event.preventDefault();
          referenceDropzone.classList.remove("is-dragging");
        });
      });
      referenceDropzone.addEventListener("drop", function (event) {
        var dropped = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (dropped) self.setReferenceFile(dropped);
      });
      referenceInput.addEventListener("change", function () {
        if (referenceInput.files && referenceInput.files[0]) self.setReferenceFile(referenceInput.files[0]);
        referenceInput.value = "";
      });
    }

    var designReplace = this.pick("[data-petart-design-replace]");
    if (designReplace && fileInput) {
      designReplace.addEventListener("click", function () {
        self.clearFile();
        fileInput.click();
      });
    }
    var referenceReplace = this.pick("[data-petart-reference-replace]");
    if (referenceReplace && referenceInput) {
      referenceReplace.addEventListener("click", function () {
        self.clearReferenceFile();
        referenceInput.click();
      });
    }

    var describeInput = this.pick("[data-petart-describe]");
    if (describeInput) {
      describeInput.addEventListener("input", function () {
        self.syncSubmitState();
      });
    }
    var editPrompt = this.pick("[data-petart-edit-prompt]");
    if (editPrompt) {
      editPrompt.addEventListener("input", function () {
        self.syncSubmitState();
      });
    }
    var newDesign = this.pick("[data-petart-new-design]");
    if (newDesign) {
      newDesign.addEventListener("click", function () {
        self.setModalMode("create");
      });
    }
    var tryPhoto = this.pick("[data-petart-try-photo]");
    if (tryPhoto) {
      tryPhoto.addEventListener("click", function () {
        self.tryAnotherPhoto();
      });
    }
    var describeUpload = this.pick("[data-petart-describe-upload]");
    if (describeUpload) {
      describeUpload.addEventListener("input", function () {
        self.syncSubmitState();
      });
    }
    var metalNotes = this.pick("[data-petart-metal-notes]");
    if (metalNotes) {
      metalNotes.addEventListener("input", function () {
        self.syncSubmitState();
      });
    }
    var customizeToggle = this.pick("[data-petart-customize-toggle]");
    if (customizeToggle) {
      customizeToggle.addEventListener("change", function () {
        self.syncCustomizePanel();
      });
    }
    var previewReplace = this.pick("[data-petart-preview-replace]");
    var fileInputReplace = this.pick("[data-petart-file]");
    if (previewReplace && fileInputReplace) {
      previewReplace.addEventListener("click", function () {
        self.clearFile();
        fileInputReplace.click();
      });
    }

    var submitButton = this.pick("[data-petart-submit]");
    if (submitButton) {
      submitButton.addEventListener("click", function () {
        self.submit();
      });
    }
    var stepPrev = this.pick("[data-petart-step-prev]");
    var stepNext = this.pick("[data-petart-step-next]");
    if (stepPrev) {
      stepPrev.addEventListener("click", function () {
        self.showStep(self.stepIndex - 1);
      });
    }
    if (stepNext) {
      stepNext.addEventListener("click", function () {
        self.showStep(self.stepIndex + 1);
      });
    }
    var restart = this.pick("[data-petart-restart]");
    if (restart) {
      restart.addEventListener("click", function () {
        self.pending = null;
        self.clearFile();
        self.showPanel("form");
      });
    }
    var accept = this.pick("[data-petart-accept]");
    if (accept) {
      accept.addEventListener("click", function () {
        self.acceptDesign();
      });
    }

    var cropReplace = this.pick("[data-petart-crop-replace]");
    if (cropReplace && fileInput) {
      cropReplace.addEventListener("click", function () {
        self.clearFile();
        fileInput.click();
      });
    }
    this.pick("[data-petart-crop-zoom]").addEventListener("input", function (event) {
      if (!self.crop) return;
      self.crop.zoom = Number(event.target.value) / 100;
      self.drawCrop();
    });
    this.pick("[data-petart-crop-rotate]").addEventListener("click", function () {
      if (!self.crop) return;
      self.crop.rotation = (self.crop.rotation + 90) % 360;
      self.crop.offsetX = 0;
      self.crop.offsetY = 0;
      self.drawCrop();
    });
    this.bindCropDrag();

    // Reopening after closing mid-generation should land on whatever is current.
    this.pick("[data-petart-hint]").addEventListener("click", function () {
      if (self.generating || self.pending) self.openModal();
    });

    // Keep the SIZE rail label in sync when the customer picks another size.
    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) {
        self.refreshSizeRail();
      }
    });
  };

  Customizer.prototype.ownsNode = function (node) {
    if (!node) return false;
    return this.scopes().some(function (scope) {
      return scope.contains(node);
    });
  };

  /* --- Cropper ----------------------------------------------------------- */

  Customizer.prototype.bindCropDrag = function () {
    var self = this;
    var frame = this.pick("[data-petart-crop-frame]");
    var dragging = false;
    var startX = 0;
    var startY = 0;
    var originX = 0;
    var originY = 0;

    frame.addEventListener("pointerdown", function (event) {
      if (!self.crop) return;
      dragging = true;
      startX = event.clientX;
      startY = event.clientY;
      originX = self.crop.offsetX;
      originY = self.crop.offsetY;
      frame.classList.add("is-grabbing");
      frame.setPointerCapture(event.pointerId);
    });

    frame.addEventListener("pointermove", function (event) {
      if (!dragging || !self.crop) return;
      event.preventDefault();
      self.crop.offsetX = originX + (event.clientX - startX);
      self.crop.offsetY = originY + (event.clientY - startY);
      self.drawCrop();
    });

    ["pointerup", "pointercancel", "pointerleave"].forEach(function (name) {
      frame.addEventListener(name, function () {
        dragging = false;
        frame.classList.remove("is-grabbing");
      });
    });

    // The transform is expressed in frame pixels, so it has to be recomputed
    // whenever the frame itself is resized.
    window.addEventListener("resize", function () {
      if (!self.crop || !self.isModalOpen()) return;
      sizeCropFrame(frame, parseRatio(self.config && self.config.aspectRatio));
      self.drawCrop();
    });
  };

  /** Effective on-screen size of the image once the 90 degree steps apply. */
  Customizer.prototype.cropExtent = function () {
    var crop = this.crop;
    var turned = crop.rotation === 90 || crop.rotation === 270;
    return {
      width: turned ? crop.naturalHeight : crop.naturalWidth,
      height: turned ? crop.naturalWidth : crop.naturalHeight,
    };
  };

  Customizer.prototype.drawCrop = function () {
    var crop = this.crop;
    if (!crop) return;

    var frame = this.pick("[data-petart-crop-frame]");
    var image = this.pick("[data-petart-crop-image]");
    var frameWidth = frame.clientWidth;
    var frameHeight = frame.clientHeight;
    if (!frameWidth || !frameHeight) return;

    var extent = this.cropExtent();
    // Cover fit: the smallest scale where the photo still fills the frame, so
    // there is never a transparent gap inside the crop.
    var base = Math.max(frameWidth / extent.width, frameHeight / extent.height);
    var scale = base * crop.zoom;

    var maxX = Math.max(0, (extent.width * scale - frameWidth) / 2);
    var maxY = Math.max(0, (extent.height * scale - frameHeight) / 2);
    crop.offsetX = clamp(crop.offsetX, -maxX, maxX);
    crop.offsetY = clamp(crop.offsetY, -maxY, maxY);
    crop.scale = scale;

    image.style.width = crop.naturalWidth + "px";
    image.style.height = crop.naturalHeight + "px";
    image.style.marginLeft = -crop.naturalWidth / 2 + "px";
    image.style.marginTop = -crop.naturalHeight / 2 + "px";
    image.style.transform =
      "translate(" + crop.offsetX + "px, " + crop.offsetY + "px) rotate(" +
      crop.rotation + "deg) scale(" + scale + ")";
  };

  /**
   * Re-renders the visible crop into a canvas at print-friendly resolution.
   * Falls back to the untouched file whenever canvas export is unavailable.
   */
  Customizer.prototype.exportCrop = function () {
    var self = this;
    var crop = this.crop;
    if (!crop || !crop.image) return Promise.resolve(this.file);

    var frame = this.pick("[data-petart-crop-frame]");
    var frameWidth = frame.clientWidth;
    var frameHeight = frame.clientHeight;
    if (!frameWidth || !frameHeight) return Promise.resolve(this.file);

    var ratio = frameWidth / frameHeight;
    var outWidth = ratio >= 1 ? CROP_OUTPUT_EDGE : Math.round(CROP_OUTPUT_EDGE * ratio);
    var outHeight = ratio >= 1 ? Math.round(CROP_OUTPUT_EDGE / ratio) : CROP_OUTPUT_EDGE;

    var canvas = document.createElement("canvas");
    canvas.width = outWidth;
    canvas.height = outHeight;
    var ctx = canvas.getContext && canvas.getContext("2d");
    if (!ctx || !canvas.toBlob) return Promise.resolve(this.file);

    var frameToOutput = outWidth / frameWidth;

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, outWidth, outHeight);
    ctx.save();
    ctx.translate(outWidth / 2, outHeight / 2);
    ctx.scale(frameToOutput, frameToOutput);
    ctx.translate(crop.offsetX, crop.offsetY);
    ctx.rotate((crop.rotation * Math.PI) / 180);
    ctx.scale(crop.scale, crop.scale);
    ctx.drawImage(
      crop.image,
      -crop.naturalWidth / 2,
      -crop.naturalHeight / 2,
      crop.naturalWidth,
      crop.naturalHeight,
    );
    ctx.restore();

    return new Promise(function (resolve) {
      canvas.toBlob(
        function (blob) {
          if (!blob) {
            resolve(self.file);
            return;
          }
          resolve(new File([blob], "design-source.jpg", { type: "image/jpeg" }));
        },
        "image/jpeg",
        0.92,
      );
    });
  };

  Customizer.prototype.clearFile = function () {
    this.file = null;
    this.sourceKey = "";
    if (this.crop && this.crop.objectUrl) URL.revokeObjectURL(this.crop.objectUrl);
    this.crop = null;
    this.pick("[data-petart-cropper]").hidden = true;
    this.pick("[data-petart-preview]").hidden = true;
    this.pick("[data-petart-dropzone]").hidden = false;
    this.setHidden("[data-petart-customize]", true);
    this.setHidden("[data-petart-customize-panel]", true);
    var customizeToggle = this.pick("[data-petart-customize-toggle]");
    if (customizeToggle) customizeToggle.checked = false;
    var describeUpload = this.pick("[data-petart-describe-upload]");
    if (describeUpload) describeUpload.value = "";
    this.setAnalyzeStatus("");
    this.resetDesignSlot();
    this.syncSubmitState();
  };

  Customizer.prototype.clearReferenceFile = function () {
    this.referenceFile = null;
    this.referenceKey = "";
    if (this.referenceObjectUrl) URL.revokeObjectURL(this.referenceObjectUrl);
    this.referenceObjectUrl = "";
    this.resetReferenceSlot();
    this.syncSubmitState();
  };

  Customizer.prototype.resetDesignSlot = function () {
    var thumb = this.pick("[data-petart-design-thumb]");
    var dropzone = this.pick("[data-petart-design-dropzone]");
    var replace = this.pick("[data-petart-design-replace]");
    if (thumb) {
      thumb.hidden = true;
      thumb.removeAttribute("src");
    }
    if (dropzone) {
      var empty = dropzone.querySelector(".petart__dropzone-empty");
      if (empty) empty.hidden = false;
    }
    if (replace) replace.hidden = true;
  };

  Customizer.prototype.resetReferenceSlot = function () {
    var thumb = this.pick("[data-petart-reference-thumb]");
    var dropzone = this.pick("[data-petart-reference-dropzone]");
    var replace = this.pick("[data-petart-reference-replace]");
    if (thumb) {
      thumb.hidden = true;
      thumb.removeAttribute("src");
    }
    if (dropzone) {
      var empty = dropzone.querySelector(".petart__dropzone-empty");
      if (empty) empty.hidden = false;
    }
    if (replace) replace.hidden = true;
  };

  Customizer.prototype.syncCustomizePanel = function () {
    var toggle = this.pick("[data-petart-customize-toggle]");
    var panel = this.pick("[data-petart-customize-panel]");
    if (!toggle || !panel) return;
    panel.hidden = !toggle.checked;
  };

  Customizer.prototype.setAnalyzeStatus = function (message) {
    var node = this.pick("[data-petart-analyze-status]");
    if (!node) return;
    node.textContent = message || "";
    node.hidden = !message;
  };

  Customizer.prototype.describeText = function () {
    if (this.modalMode === "edit") {
      var editNode = this.pick("[data-petart-edit-prompt]");
      var editText = editNode ? editNode.value.trim() : "";
      if (editText) return editText;
      return this.describeTextFromFields();
    }
    if (this.activeTab() === "describe") {
      var describeNode = this.pick("[data-petart-describe]");
      return describeNode ? describeNode.value.trim() : "";
    }
    var uploadNode = this.pick("[data-petart-describe-upload]");
    return uploadNode ? uploadNode.value.trim() : "";
  };

  Customizer.prototype.hasExistingDesign = function () {
    return Boolean(this.designId && this.previewUrl);
  };

  Customizer.prototype.shouldOpenForEdit = function (trigger) {
    if (!this.hasExistingDesign()) return false;
    if (trigger.closest("[data-petart-edit-bar]")) return true;
    if (trigger.hasAttribute("data-petart-edit-link")) return true;
    if (trigger.hasAttribute("data-petart-size-upload") && this.previewUrl) return true;
    if (trigger.closest(".petart__size-rail--ready")) return true;
    if (trigger.closest("[data-petart-hotspot]")) return false;
    return false;
  };

  Customizer.prototype.setModalMode = function (mode) {
    this.modalMode = mode === "edit" ? "edit" : "create";
    var dialog = this.pick("[data-petart-dialog]");
    if (dialog) dialog.classList.toggle("petart__dialog--edit", this.modalMode === "edit");

    this.setHidden("[data-petart-edit-view]", this.modalMode !== "edit");
    this.setHidden("[data-petart-create-view]", this.modalMode === "edit");
    this.setHidden("[data-petart-modal-subtitle]", this.modalMode === "edit");
    this.setHidden("[data-petart-try-photo]", this.modalMode !== "edit");
    var footer = this.pick("[data-petart-form-footer]");
    if (footer) footer.classList.toggle("petart__footer--split", this.modalMode === "edit");

    var ui = (this.config && this.config.ui) || {};
    if (this.modalMode === "edit") {
      this.populateEditView();
      this.setText("[data-petart-modal-title]", "Edit your design");
      this.setText("[data-petart-submit-label]", "Regenerate design");
    } else {
      this.setText("[data-petart-modal-title]", ui.title || "Create your design");
      this.setText("[data-petart-modal-subtitle]", ui.subtitle || "");
      this.setText("[data-petart-submit-label]", "Create design");
    }
    this.syncSubmitState();
  };

  Customizer.prototype.tryAnotherPhoto = function () {
    this.setModalMode("create");
    this.selectTab("upload");
    this.clearFile();
    this.clearReferenceFile();
    var metalNotes = this.pick("[data-petart-metal-notes]");
    if (metalNotes) metalNotes.value = "";
    var fileInput = this.pick("[data-petart-file]");
    if (fileInput) fileInput.click();
  };

  Customizer.prototype.populateEditView = function () {
    var img = this.pick("[data-petart-edit-preview]");
    if (img && this.previewUrl) img.src = this.previewUrl;
    var prompt = this.pick("[data-petart-edit-prompt]");
    if (!prompt) return;
    if (!prompt.value.trim()) {
      var saved = this.describeTextFromFields();
      if (saved) prompt.value = saved;
    }
  };

  Customizer.prototype.describeTextFromFields = function () {
    var metalNotes = this.pick("[data-petart-metal-notes]");
    var uploadNode = this.pick("[data-petart-describe-upload]");
    var tabNode = this.pick("[data-petart-describe]");
    var metalText = metalNotes ? metalNotes.value.trim() : "";
    var uploadText = uploadNode ? uploadNode.value.trim() : "";
    var tabText = tabNode ? tabNode.value.trim() : "";
    return metalText || uploadText || tabText;
  };

  Customizer.prototype.analyzeUploadedImage = function (file) {
    var self = this;
    var token = ++this.analyzeToken;
    this.setAnalyzeStatus("Analyzing your image...");
    this.uploadSource(file)
      .then(function (sourceKey) {
        if (token !== self.analyzeToken) return null;
        self.sourceKey = sourceKey;
        return postJson(self.proxy + "/analyze", {
          sourceKey: sourceKey,
          productId: self.productId,
        });
      })
      .then(function (result) {
        if (!result || token !== self.analyzeToken) return;
        if (result.description) {
          var uploadNode = self.pick("[data-petart-describe-upload]");
          if (uploadNode) uploadNode.value = result.description;
          var customizeToggle = self.pick("[data-petart-customize-toggle]");
          if (customizeToggle) customizeToggle.checked = true;
          self.syncCustomizePanel();
        }
        self.setAnalyzeStatus("");
        self.syncSubmitState();
      })
      .catch(function () {
        if (token !== self.analyzeToken) return;
        self.setAnalyzeStatus("");
        self.syncSubmitState();
      });
  };

  Customizer.prototype.selectTab = function (name) {
    this.pickAll("[data-petart-tab]").forEach(function (tab) {
      tab.classList.toggle("is-active", tab.dataset.petartTab === name);
    });
    this.pickAll("[data-petart-tabpanel]").forEach(function (panel) {
      panel.hidden = panel.dataset.petartTabpanel !== name;
    });
    this.setHidden("[data-petart-customize]", name !== "upload" || !this.file || this.layoutIsMetal());
    this.setHidden("[data-petart-upload-dual]", !this.layoutIsMetal() || name !== "upload");
    this.setHidden("[data-petart-upload-notes]", !this.layoutIsMetal() || name !== "upload");
    this.setHidden("[data-petart-dual-upload-help]", !this.layoutIsMetal() || name !== "upload");
    this.syncSubmitState();
  };

  Customizer.prototype.setFile = function (file) {
    var self = this;
    if (ALLOWED_TYPES.indexOf(file.type) === -1) {
      this.showError("Please choose a JPG, PNG or WebP image.");
      return;
    }
    if (file.size > MAX_BYTES) {
      this.showError("Images must be smaller than 10 MB.");
      return;
    }

    this.showError("");
    this.file = file;
    this.sourceKey = "";

    var objectUrl = URL.createObjectURL(file);
    if (this.layoutIsMetal()) {
      var designThumb = this.pick("[data-petart-design-thumb]");
      var designDropzone = this.pick("[data-petart-design-dropzone]");
      var designReplace = this.pick("[data-petart-design-replace]");
      if (designThumb) {
        designThumb.src = objectUrl;
        designThumb.hidden = false;
      }
      if (designDropzone) {
        var designEmpty = designDropzone.querySelector(".petart__dropzone-empty");
        if (designEmpty) designEmpty.hidden = true;
      }
      if (designReplace) designReplace.hidden = false;
    } else {
      var previewImage = this.pick("[data-petart-preview-image]");
      if (previewImage) previewImage.src = objectUrl;
      this.pick("[data-petart-dropzone]").hidden = true;
      this.pick("[data-petart-preview]").hidden = false;
      this.pick("[data-petart-cropper]").hidden = true;
      this.setHidden("[data-petart-customize]", false);
      this.setHidden("[data-petart-customize-panel]", true);
      var customizeToggle = this.pick("[data-petart-customize-toggle]");
      if (customizeToggle) customizeToggle.checked = false;
      var describeUpload = this.pick("[data-petart-describe-upload]");
      if (describeUpload) describeUpload.value = "";
    }

    if (this.crop && this.crop.objectUrl) URL.revokeObjectURL(this.crop.objectUrl);
    this.crop = { objectUrl: objectUrl };

    this.analyzeUploadedImage(file);
    this.syncSubmitState();
  };

  Customizer.prototype.setReferenceFile = function (file) {
    if (ALLOWED_TYPES.indexOf(file.type) === -1) {
      this.showError("Please choose a JPG, PNG or WebP image.");
      return;
    }
    if (file.size > MAX_BYTES) {
      this.showError("Images must be smaller than 10 MB.");
      return;
    }

    this.showError("");
    this.referenceFile = file;
    this.referenceKey = "";
    if (this.referenceObjectUrl) URL.revokeObjectURL(this.referenceObjectUrl);
    this.referenceObjectUrl = URL.createObjectURL(file);

    var thumb = this.pick("[data-petart-reference-thumb]");
    var dropzone = this.pick("[data-petart-reference-dropzone]");
    var replace = this.pick("[data-petart-reference-replace]");
    if (thumb) {
      thumb.src = this.referenceObjectUrl;
      thumb.hidden = false;
    }
    if (dropzone) {
      var empty = dropzone.querySelector(".petart__dropzone-empty");
      if (empty) empty.hidden = true;
    }
    if (replace) replace.hidden = false;
    this.syncSubmitState();
  };

  Customizer.prototype.activeTab = function () {
    var active = this.pick("[data-petart-tab].is-active");
    return active ? active.dataset.petartTab : "upload";
  };

  Customizer.prototype.syncSubmitState = function () {
    var submit = this.pick("[data-petart-submit]");
    if (!submit) return;
    if (this.generateMode() === "none") {
      submit.disabled = !this.attributesReady();
      return;
    }
    if (this.modalMode === "edit") {
      submit.disabled = !this.attributesReady() || !this.designId;
      return;
    }
    var describe = this.describeText();
    var photoReady =
      Boolean(this.file) ||
      Boolean(this.referenceFile) ||
      (this.activeTab() === "describe" && describe.length > 2);
    if (this.layoutIsMetal() && this.activeTab() === "upload" && describe.length > 2) {
      photoReady = true;
    }
    var ready = this.allowPhoto() ? photoReady : this.attributesReady();
    if (this.allowPhoto()) ready = photoReady && this.attributesReady();
    else if (this.config.allowPromptOnly) ready = describe.length > 2 && this.attributesReady();
    else ready = this.attributesReady();
    submit.disabled = !ready;
  };

  Customizer.prototype.showError = function (message) {
    var node = this.pick("[data-petart-error]");
    if (!node) return;
    node.textContent = message || "";
    node.hidden = !message;
  };

  Customizer.prototype.showPanel = function (name) {
    this.pickAll("[data-petart-panel]").forEach(function (panel) {
      panel.hidden = panel.dataset.petartPanel !== name;
    });
  };

  Customizer.prototype.isModalOpen = function () {
    return !this.pick("[data-petart-modal]").hidden;
  };

  Customizer.prototype.openModal = function (options) {
    options = options || {};
    this.pick("[data-petart-modal]").hidden = false;
    document.documentElement.style.overflow = "hidden";

    if (this.generating) {
      this.showPanel("progress");
      return;
    }

    this.showPanel("form");
    var wantEdit =
      options.edit === true ||
      (options.edit !== false && this.shouldOpenEditorFromUrl() && this.hasExistingDesign());
    this.setModalMode(wantEdit ? "edit" : "create");
  };

  Customizer.prototype.closeModal = function () {
    var modal = this.pick("[data-petart-modal]");
    if (modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    if (this.generating) {
      this.setHint("Still creating your design... we will tell you when it is ready.", false);
    }
  };

  Customizer.prototype.currentVariantId = function () {
    var form = this.cartForm();
    var input = form && form.querySelector('[name="id"]');
    return (input && input.value) || this.root.dataset.variantId || "";
  };

  Customizer.prototype.submit = function () {
    var self = this;
    var nameNode = this.pick("[data-petart-name]");
    var describe = this.describeText();
    var name = nameNode ? nameNode.value.trim() : "";
    var useFile = Boolean(this.file);

    this.showError("");
    if (!this.attributesReady()) {
      this.showError("Please complete the required options.");
      return;
    }

    if (this.generateMode() === "none") {
      this.applyToForm();
      this.setHint("Your options are saved. You can add this item to the cart.", false);
      return;
    }

    this.generating = true;
    if (this.presentation() === "scene") this.showPanel("progress");
    this.setProgress(2);
    this.refreshSizeRail();

    var uploaded = useFile
      ? this.sourceKey
        ? Promise.resolve(this.sourceKey)
        : this.uploadSource(this.file)
      : Promise.resolve("");
    var referenceUploaded = this.referenceFile
      ? this.referenceKey
        ? Promise.resolve(this.referenceKey)
        : this.uploadSource(this.referenceFile)
      : Promise.resolve(this.referenceKey || "");

    Promise.all([uploaded, referenceUploaded])
      .then(function (keys) {
        self.setProgress(18);
        var payload = {
          productId: self.productId,
          variantId: self.currentVariantId(),
          sourceKey: keys[0],
          referenceKey: keys[1],
          promptText: describe,
          name: name,
          tone: self.tone,
          attributes: self.attributes,
          clientId: clientId(),
        };
        if (self.modalMode === "edit" && self.designId) {
          payload.parentDesignId = self.designId;
        }
        return postJson(self.proxy + "/design", payload);
      })
      .then(function (design) {
        if (typeof design.remaining === "number") self.setRemaining(design.remaining);
        return self.poll(design.id);
      })
      .then(function (design) {
        self.generating = false;
        self.pending = design;
        self.designId = design.id;
        self.previewUrl = design.previewUrl;
        self.populateEditView();
        self.persistDesign();
        self.applyToForm();
        self.refreshSizeRail();
        // The product page already carries price, variants and policies, so the
        // result stays here instead of bouncing to a second buy page.
        self.showPreviewOnGallery(design.previewUrl);
        self.showPanel("form");
        self.setModalMode("edit");
        self.setHint("", false);
      })
      .catch(function (error) {
        self.generating = false;
        self.showPanel("form");
        self.refreshSizeRail();
        var message = error.message || "Something went wrong. Please try again.";
        // Safari / WeChat often surface R2 CORS or network aborts as "Load failed".
        if (/^load failed$/i.test(message) || /failed to fetch/i.test(message)) {
          message = "Upload failed. Please try again with a JPG or PNG photo.";
        }
        self.showError(message);
        if (!self.isModalOpen()) {
          self.setHint("We could not finish your design. Tap to try again.", true);
        }
      });
  };

  /**
   * A single result needs no chooser, so the strip only appears when the
   * template actually asked for more than one design.
   */
  Customizer.prototype.renderOptions = function (design) {
    var self = this;
    var wrapper = this.pick("[data-petart-options]");
    var grid = this.pick("[data-petart-options-grid]");
    var options = design.options || [];

    grid.textContent = "";
    if (options.length < 2) {
      wrapper.hidden = true;
      return;
    }

    options.forEach(function (option) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "petart__option";
      button.setAttribute("aria-label", "Design option " + (option.index + 1));
      if (option.index === design.selectedIndex) button.classList.add("is-active");

      var thumb = document.createElement("img");
      thumb.src = option.previewUrl;
      thumb.alt = "";
      button.appendChild(thumb);

      button.addEventListener("click", function () {
        self.selectOption(design, option.index);
      });
      grid.appendChild(button);
    });

    wrapper.hidden = false;
  };

  Customizer.prototype.selectOption = function (design, index) {
    var self = this;
    if (design.selectedIndex === index) return;

    var previous = design.selectedIndex;
    var option = (design.options || []).filter(function (entry) {
      return entry.index === index;
    })[0];
    if (!option) return;

    // Applied straight away so the choice feels instant; reverted if the
    // server rejects it, which keeps the preview honest about what will ship.
    design.selectedIndex = index;
    design.previewUrl = option.previewUrl;
    this.previewUrl = option.previewUrl;
    this.designId = design.id;
    this.pick("[data-petart-result]").src = option.previewUrl;
    this.renderOptions(design);
    this.showPreviewOnGallery(option.previewUrl);
    this.persistDesign();
    this.applyToForm();

    postJson(this.proxy + "/design/" + design.id + "/select", { index: index }).catch(
      function (error) {
        design.selectedIndex = previous;
        var fallback = (design.options || []).filter(function (entry) {
          return entry.index === previous;
        })[0];
        if (fallback) {
          design.previewUrl = fallback.previewUrl;
          self.pick("[data-petart-result]").src = fallback.previewUrl;
        }
        self.renderOptions(design);
        self.setHint(error.message || "That choice could not be saved.", true);
      },
    );
  };

  Customizer.prototype.setRemaining = function (value) {
    this.remaining = value;
    var text =
      value < 0
        ? ""
        : value === 0
          ? "That was your last design for today."
          : value === 1
            ? "1 design left today."
            : value + " designs left today.";

    ["[data-petart-quota]", "[data-petart-quota-done]"].forEach(
      function (selector) {
        var node = this.pick(selector);
        if (!node) return;
        node.textContent = text;
        node.hidden = !text;
      }.bind(this),
    );
  };

  Customizer.prototype.uploadSource = function (file) {
    var self = this;
    return postJson(this.proxy + "/upload", {
      contentType: file.type || "image/jpeg",
      size: file.size,
    }).then(function (probe) {
      self.setProgress(12);

      // Always post the file through the app proxy. Presigned browser→R2 PUTs
      // fail without bucket CORS and surface as a useless "Load failed" on phones.
      var form = new FormData();
      form.append("file", file);
      return fetch(self.proxy + "/upload", {
        method: "POST",
        body: form,
        credentials: "same-origin",
      })
        .then(readJson)
        .then(function (stored) {
          if (!stored.key) throw new Error("Upload failed. Please try again.");
          return stored.key;
        })
        .catch(function (error) {
          var message = error && error.message ? error.message : "";
          if (/load failed|failed to fetch|networkerror/i.test(message)) {
            throw new Error("Upload failed. Please check your connection and try again.");
          }
          throw error;
        });
    });
  };

  Customizer.prototype.setProgress = function (value, title) {
    var bar = this.pick("[data-petart-bar]");
    if (bar) bar.style.width = Math.max(4, Math.min(100, value)) + "%";
    this.pick("[data-petart-progress-title]").textContent = title || stageText(value);
  };

  Customizer.prototype.poll = function (designId) {
    var self = this;
    var startedAt = Date.now();

    return new Promise(function (resolve, reject) {
      function tick() {
        if (Date.now() - startedAt > POLL_TIMEOUT) {
          reject(new Error("This is taking longer than usual. Please try again."));
          return;
        }
        getJson(self.proxy + "/design/" + encodeURIComponent(designId))
          .then(function (design) {
            if (design.status === "READY" && design.previewUrl) {
              self.setProgress(100);
              resolve(design);
              return;
            }
            if (design.status === "FAILED") {
              reject(new Error(design.error || "We could not create that design."));
              return;
            }
            self.setProgress(Math.max(18, design.progress || 0));
            self.pollTimer = window.setTimeout(tick, POLL_INTERVAL);
          })
          .catch(reject);
      }
      tick();
    });
  };

  Customizer.prototype.acceptDesign = function () {
    if (!this.pending) return;
    this.designId = this.pending.id;
    this.previewUrl = this.pending.previewUrl;

    this.persistDesign();
    this.applyToForm();
    this.showPreviewOnGallery(this.previewUrl);

    var hotspot =
      (this.galleryStage && this.galleryStage.querySelector("[data-petart-hotspot]")) ||
      this.pick("[data-petart-hotspot]");
    if (hotspot) hotspot.hidden = true;

    this.setHint("", false);
    this.refreshSizeRail();
    this.closeModal();
  };

  Customizer.prototype.designStoreKey = function () {
    return DESIGN_STORE_PREFIX + (this.productId || this.root.dataset.productId || "");
  };

  Customizer.prototype.shouldOpenEditorFromUrl = function () {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("petart") === "edit";
    } catch (error) {
      return false;
    }
  };

  Customizer.prototype.persistDesign = function () {
    if (!this.designId || !this.previewUrl) return;
    try {
      window.localStorage.setItem(
        this.designStoreKey(),
        JSON.stringify({
          id: this.designId,
          previewUrl: this.previewUrl,
          name: this.pick("[data-petart-name]") ? this.pick("[data-petart-name]").value.trim() : "",
          tone: this.tone,
          promptText: this.describeText(),
          savedAt: Date.now(),
        }),
      );
    } catch (error) {
      /* private mode / quota — gallery still works for this session */
    }
  };

  Customizer.prototype.restorePersistedDesign = function () {
    var saved = null;
    try {
      saved = JSON.parse(window.localStorage.getItem(this.designStoreKey()) || "null");
    } catch (error) {
      saved = null;
    }
    if (!saved || !saved.id || !saved.previewUrl) return;
    // Drop stale drafts after a week so a returning shopper starts fresh.
    if (saved.savedAt && Date.now() - saved.savedAt > 7 * 24 * 60 * 60 * 1000) {
      try {
        window.localStorage.removeItem(this.designStoreKey());
      } catch (error) {
        /* ignore */
      }
      return;
    }

    this.designId = saved.id;
    this.previewUrl = saved.previewUrl;
    if (saved.name) {
      var nameInput = this.pick("[data-petart-name]");
      if (nameInput && !nameInput.value) nameInput.value = saved.name;
    }
    if (saved.tone) {
      this.tone = saved.tone;
      this.pickAll(".petart__tone").forEach(function (button) {
        button.classList.toggle("is-active", button.dataset.toneId === saved.tone);
      });
    }
    if (saved.promptText) {
      var uploadDescribe = this.pick("[data-petart-describe-upload]");
      var tabDescribe = this.pick("[data-petart-describe]");
      var editPrompt = this.pick("[data-petart-edit-prompt]");
      if (uploadDescribe && !uploadDescribe.value) uploadDescribe.value = saved.promptText;
      if (tabDescribe && !tabDescribe.value) tabDescribe.value = saved.promptText;
      if (editPrompt && !editPrompt.value) editPrompt.value = saved.promptText;
      if (uploadDescribe && saved.promptText) {
        var customizeToggle = this.pick("[data-petart-customize-toggle]");
        if (customizeToggle) customizeToggle.checked = true;
        this.syncCustomizePanel();
        this.setHidden("[data-petart-customize]", false);
      }
    }

    this.applyToForm();
    this.showPreviewOnGallery(this.previewUrl);

    var hotspot =
      (this.galleryStage && this.galleryStage.querySelector("[data-petart-hotspot]")) ||
      this.pick("[data-petart-hotspot]");
    if (hotspot) hotspot.hidden = true;
    this.setHint("", false);
    this.refreshSizeRail();
  };

  Customizer.prototype.showPreviewOnGallery = function (url) {
    if (!url) return;
    var stage = this.galleryStage || this.pick("[data-petart-stage]");
    var scene =
      (stage && stage.querySelector("[data-petart-scene]")) || this.pick("[data-petart-scene]");
    if (scene) scene.src = url;
    if (stage) stage.classList.add("is-previewing");
    this.swapGallery(url);
  };

  Customizer.prototype.setHint = function (message, isError) {
    var hint = this.pick("[data-petart-hint]");
    if (!hint) return;
    hint.textContent = message || "";
    hint.hidden = !message;
    hint.classList.toggle("petart__hint--error", Boolean(isError));
    hint.classList.toggle(
      "petart__hint--action",
      Boolean(message) && Boolean(this.generating || this.pending),
    );
  };

  Customizer.prototype.cartForm = function () {
    var scope = this.root.closest(".shopify-section") || document;
    return (
      scope.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  };

  Customizer.prototype.upsertProperty = function (form, key, value) {
    var name = "properties[" + key + "]";
    var input = form.querySelector('input[name="' + name + '"][data-petart-input]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.setAttribute("data-petart-input", "");
      form.appendChild(input);
    }
    input.value = value;
  };

  Customizer.prototype.applyToForm = function () {
    var form = this.cartForm();
    if (!form) return;
    if (this.generateMode() !== "none" && !this.designId) return;

    if (this.designId) this.upsertProperty(form, DESIGN_PROPERTY, this.designId);
    if (this.previewUrl) this.upsertProperty(form, PREVIEW_PROPERTY, this.previewUrl);

    var nameNode = this.pick("[data-petart-name]");
    var name = nameNode ? nameNode.value.trim() : "";
    if (name) this.upsertProperty(form, NAME_PROPERTY, name);

    var list = (this.config && this.config.attributes) || [];
    list.forEach(function (attribute) {
      var value = String(this.attributes[attribute.id] || "").trim();
      if (value) this.upsertProperty(form, attribute.label || attribute.id, value);
    }, this);

    this.setAddToCartEnabled(true);
  };

  /**
   * Horizon re-renders the buy buttons through the section rendering API on
   * every variant change, which drops our hidden inputs and resets the button.
   * A cheap poll puts both back.
   */
  Customizer.prototype.startSync = function () {
    if (this.syncTimer) return;
    var self = this;
    this.syncTimer = window.setInterval(function () {
      var form = self.cartForm();
      if (!form) return;
      if (self.designId || self.generateMode() === "none") {
        if (!form.querySelector("[data-petart-input]")) self.applyToForm();
      } else if (self.config.requireDesign) {
        self.setAddToCartEnabled(false);
      }
    }, 1200);
  };

  Customizer.prototype.buyButtons = function (form) {
    var buttons = Array.prototype.slice.call(
      form.querySelectorAll('[type="submit"], [name="add"]'),
    );
    if (form.id) {
      Array.prototype.slice
        .call(document.querySelectorAll('[form="' + form.id + '"]'))
        .forEach(function (node) {
          if (node.tagName === "BUTTON" || node.type === "submit") buttons.push(node);
        });
    }
    return buttons;
  };

  Customizer.prototype.setAddToCartEnabled = function (enabled) {
    var form = this.cartForm();
    if (!form) return;
    this.buyButtons(form).forEach(function (button) {
      if (enabled) {
        // Only re-enable what this block disabled, so sold-out states survive.
        if (button.hasAttribute("data-petart-disabled")) {
          button.removeAttribute("data-petart-disabled");
          button.disabled = false;
        }
      } else if (!button.disabled) {
        button.setAttribute("data-petart-disabled", "");
        button.disabled = true;
      }
    });
  };

  /**
   * The guard lives on the document in the capture phase: themes that build the
   * cart request in JavaScript still dispatch submit on the form, and listening
   * here survives the form element being replaced on variant changes.
   */
  Customizer.prototype.enforceDesignRequirement = function () {
    this.startSync();
    if (this.generateMode() === "none") {
      if (this.config.requireDesign && !this.attributesReady()) this.setAddToCartEnabled(false);
      return;
    }
    if (!this.config.requireDesign || this.formGuardBound) return;

    var self = this;
    this.formGuardBound = true;
    this.setAddToCartEnabled(false);

    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (self.designId || !form || !form.matches || !form.matches('form[action*="/cart/add"]')) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        self.setHint("Please create your design before adding this item to the cart.", true);
        if (self.presentation() === "scene") self.openModal();
      },
      true,
    );

    this.setHint(
      this.allowPhoto() ? "Upload a photo to create your design." : "Complete the options to create your design.",
      false,
    );
  };

  Customizer.prototype.swapGallery = function (url) {
    if (this.root.dataset.swapGallery !== "true" || !url) return;

    var scope =
      document.querySelector(
        'media-gallery, .product__media-wrapper, .product-media-container, [id^="MediaGallery"], .product__media-list',
      ) ||
      this.root.closest(".shopify-section") ||
      document.querySelector(".product") ||
      document;

    var images = Array.prototype.slice.call(
      scope.querySelectorAll(
        "img.product__media-item, media-gallery img, .product-media-container img, .product__media img, .thumbnail-list img, .product__thumbnails img, button[data-media-id] img, .slider__slide img, [id^='Slide-'] img, [id^='Thumb-'] img",
      ),
    );

    // Fallback: any image inside the product media section that is not our UI.
    if (!images.length && scope.querySelectorAll) {
      images = Array.prototype.slice.call(scope.querySelectorAll("img")).filter(function (image) {
        return !image.closest("[data-petart], .petart__modal");
      });
    }

    images.forEach(function (image) {
      if (image.closest("[data-petart-modal], .petart__modal")) return;
      if (image.hasAttribute("data-petart-scene")) return;
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = url;
      image.setAttribute("data-petart-swapped", "true");
      var picture = image.closest("picture");
      if (picture) {
        Array.prototype.slice.call(picture.querySelectorAll("source")).forEach(function (source) {
          source.remove();
        });
      }
    });
  };

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll("[data-petart]")).forEach(function (root) {
      if (root.dataset.petartReady === "true") return;
      root.dataset.petartReady = "true";
      new Customizer(root).init();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a full page load.
  document.addEventListener("shopify:section:load", boot);
})();
